<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12">
        <!-- Botón de regreso -->
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
          >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text" style="color: white;">
          {{ title }}
        </div>

        <!-- Formulario de consulta -->
        <v-row align="center">
          <v-col cols="12">
          <div style="color: white; font-size: 16px; margin-bottom: 2px;">Describa en pocas palabras su consulta:</div>
          <v-text-field
            v-model="titulo"
            required
            persistent-hint
            class="custom-input"
            style="margin-top: -15px; margin-bottom: 0; min-height: 56px;"  
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <div style="color: white; font-size: 16px; margin-bottom: 2px; margin-top: -34px">Describa en detalle la consulta:</div>
          <v-textarea
            name="input-7-1"
            v-model="descripcion"
            persistent-hint
            class="custom-input"
            style="margin-top: -15px; margin-bottom: 0; min-height: 56px;"  
          ></v-textarea>
        </v-col>


          <v-col cols="12">
            <div style="color: white; font-size: 16px; margin-bottom: 4px;margin-top: -34px">Adjuntar archivos</div>
            <v-file-input
              show-size
              v-model="files"
              :items="files"
              multiple
              counter
              accept="image/*"
              class="custom-input"
            >
              <template v-slot:prepend>
                <v-icon>mdi-attachment</v-icon>
              </template>

              <template v-slot:selection="{ text }">
                <v-chip
                  small
                  label
                  close
                  @click:close="remove(index)"
                  color="primary"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </v-col>
        </v-row>

        <!-- Botón para crear consulta -->
        <v-row align="center">
          <v-col cols="12" md="6">
            <v-btn
              color="success"
              elevation="7"
              large
              v-on:click="examen = true"
              @click="addConsulta()"
            >
              Crear consulta
            </v-btn>
          </v-col>
        </v-row>

        <!-- Mis consultas generales -->
        <div>
          <br />
          <h2 style="color: white;">Mis consultas generales</h2>

          <!-- Acordeón para consultas generales en pantallas pequeñas -->
          <v-expansion-panels
            v-if="consultas.length > 0"
            focusable
            class="d-sm-none"
          >
            <v-expansion-panel
              v-for="(consultaData, consultaKey) in consultas"
              :key="consultaKey"
              class="mb-1"
              style="border-radius: 5px; overflow: hidden;"  
            >
              <v-expansion-panel-header
                style="background-color: #e0e0e0; border-radius: 5px 5px 0 0;"  
              >
                {{ consultaData.titulo }}
              </v-expansion-panel-header>
              <v-expansion-panel-content
                style="border-radius: 0 0 5px 5px;"  
              >
                <div>
                  <p class="mt-5"><strong>Descripción:</strong> {{ consultaData.descripcion }}</p>
                  <p v-if="consultaData.ConsultaGeneralesRespuesta">
                    <strong>Respuesta:</strong> {{ consultaData.ConsultaGeneralesRespuesta.respuesta }}
                  </p>
                  <p v-else></p>
                  <p><strong>Respondido por:</strong> {{ consultaData.usu_nombre || 'Aún no respondido...' }}</p>

                  <!-- Calificación -->
                  <div class="star-rating-container">
                    <star-rating 
                      v-if="consultaData.ConsultaGeneralesRespuesta" 
                      v-model="consultaData.puntaje" 
                      @rating-selected="calificar($event, consultaData.id, 'G')" 
                      v-bind:increment="0.5" 
                      v-bind:max-rating="5" 
                      inactive-color="#f1f1f1"
                      active-color="#FFD700" 
                      v-bind:star-size="20" 
                      v-bind:read-only="(consultaData.tiene_puntuacion=='S'?true:false)" 
                      v-bind:show-rating="false"
                    />
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>


          <!-- Tabla para consultas generales en pantallas grandes -->
          <v-simple-table class="d-none d-md-flex">
            <thead>
              <tr>
                <th class="text-left">Título</th>
                <th class="text-left">Descripción</th>
                <th class="text-left">Respuesta</th>
                <th class="text-left">Respondido por</th>
                <th class="text-left">Calificación</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(consultaData, consultaKey) in consultas" :key="consultaKey">
                <td>{{ consultaData.titulo }}</td>
                <td>{{ consultaData.descripcion }}</td>
                <td>
                  <div v-if="consultaData.ConsultaGeneralesRespuesta">
                    {{ consultaData.ConsultaGeneralesRespuesta.respuesta }}
                  </div>
                  <div v-else></div>
                </td>
                <td>{{ consultaData.usu_nombre || 'Aún no respondido...' }}</td>
                <td>
                  <div class="star-rating-container">
                    <star-rating 
                      v-if="consultaData.ConsultaGeneralesRespuesta" 
                      v-model="consultaData.puntaje" 
                      @rating-selected="calificar($event,consultaData.id,'G')" 
                      v-bind:increment="0.5" 
                      v-bind:max-rating="5" 
                      inactive-color="#f1f1f1"
                      active-color="#FFD700" 
                      v-bind:star-size="20" 
                      v-bind:read-only="(consultaData.tiene_puntuacion=='S'?true:false)" 
                      v-bind:show-rating="false"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>

        <!-- Mis informes de pagos -->
        <div>
          <br />
          <h2 style="color: white;">Mis Informes de Pagos</h2>

 <!-- Acordeón para informes de pagos en pantallas pequeñas -->
          <v-expansion-panels
            v-if="consultasAcreditacion.length > 0"
            focusable
            class="d-sm-none"
          >
            <v-expansion-panel
              v-for="(consultaDat, consultaKey) in consultasAcreditacion"
              :key="consultaKey"
              class="mb-1 rounded"            
            >
              <v-expansion-panel-header
              style="background-color: #e0e0e0;">
                {{ consultaDat.titulo }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div>
                  <p v-if="consultaDat.ConsultaAcreditacionRespuesta" class="mt-5">
                    <strong>Respuesta:</strong> {{ consultaDat.ConsultaAcreditacionRespuesta.respuesta }}
                  </p>
                  <p v-else></p>
                  <p><strong>Respondido por:</strong> {{ consultaDat.usu_nombre || '' }}</p>

                  <!-- Calificación -->
                  <div class="star-rating-container">
                    <star-rating 
                      v-if="consultaDat.ConsultaAcreditacionRespuesta" 
                      v-model="consultaDat.puntaje" 
                      @rating-selected="calificar($event,consultaDat.id,'A')" 
                      v-bind:increment="0.5" 
                      v-bind:max-rating="5" 
                      inactive-color="#f1f1f1"
                      active-color="#FFD700" 
                      v-bind:star-size="20" 
                      v-bind:read-only="(consultaDat.tiene_puntuacion=='S'?true:false)" 
                      v-bind:show-rating="false"
                    />
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Tabla para informes de pagos en pantallas grandes -->
          <v-simple-table class="d-none d-md-flex">
            <thead>
              <tr>
                <th class="text-left">Título</th>
                <th class="text-left">Respuesta</th>
                <th class="text-left">Respondido por</th>
                <th class="text-left">Calificación</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(consultaDat, consultaKey) in consultasAcreditacion" :key="consultaKey">
                <td>{{ consultaDat.titulo }}</td>
                <td>
                  <div v-if="consultaDat.ConsultaAcreditacionRespuesta">
                    {{ consultaDat.ConsultaAcreditacionRespuesta.respuesta }}
                  </div>
                  <div v-else></div>
                </td>
                <td>{{ consultaDat.usu_nombre || '' }}</td>
                <td>
                  <div class="star-rating-container">
                    <star-rating 
                      v-if="consultaDat.ConsultaAcreditacionRespuesta" 
                      v-model="consultaDat.puntaje" 
                      @rating-selected="calificar($event,consultaDat.id,'A')" 
                      v-bind:increment="0.5" 
                      v-bind:max-rating="5" 
                      inactive-color="#f1f1f1"
                      active-color="#FFD700" 
                      v-bind:star-size="20" 
                      v-bind:read-only="(consultaDat.tiene_puntuacion=='S'?true:false)" 
                      v-bind:show-rating="false"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>


<script>
import StarRating from 'vue-star-rating'
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Consulta",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    StarRating
  },

  data: () => ({
    title:"Nueva consulta",
    dialog_desc: [],
    dialog: [],
    dialog_acred: [],
    titulo: '',
    descripcion: '',
    consultas:[],
    consultasAcreditacion:[],
    files:[],
    respuestaAcreditacion : '',
    rating:3
  }),

  methods: {

    async calificar(puntaje,idConsulta,tipo){
      let url = "consultas-generales/calificar";
      let params = new FormData();
      params.append('id_consulta',idConsulta);
      params.append('puntaje',puntaje);
      params.append('tipo',tipo);

      await this.$API
        .post({
          url: url,
          data: params
        }).then(() => {
          this.loadConsultas();
          this.titulo = "";
          this.descripcion = "";
          this.files = [];
        });  
    },
    remove (index) {
      this.files.splice(index, 1)
    },

    printConsole(data){
      // alert(JSON.stringify())
      // debugger;
      // console.log(data);
      this.respuestaAcreditacion = data.ConsultaAcreditacionRespuesta.respuesta
    },
    
    async addConsulta() {
      if(this.titulo.trim() == "" || this.descripcion.trim() == ""){
        alert('Escribe el titulo y descripción de tu consulta')
        return;
      }
      var formData = new FormData();
      formData.append('titulo',this.titulo);
      formData.append('descripcion',this.descripcion);
      formData.append('cantidadImagen',this.files.length);

      console.log(this.$refs)
      let i = 0;
      for (let file of this.files) {
          formData.append(`imagen_${i}`, file, file.name);
          i++;
      }
      console.log(formData);
      
      let url = "consultas-generales/store";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.loadConsultas();
          this.titulo = "";
          this.descripcion = "";
          this.files = [];
        });  
    },
    async loadConsultas() {
      let url = "consultas-generales";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.consultas = res;
          for (let index = 0; index < this.consultas.length; index++) {
            this.dialog = [];
            this.dialog[index] = false;
            this.dialog_desc = [];
            this.dialog_desc[index] = false;
          }
        });
    }
  },
  async loadConsultasAcreditacion() {
      let url = "consultas-acreditacion";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.consultasAcreditacion = res;
          for (let index = 0; index < this.consultasAcreditacion.length; index++) {
            this.dialog_acred = [];
            this.dialog_acred[index] = false;
          }
        });
  },

  mounted() {
    this.$API
      .get({
        url: "consultas-generales"
      }).then((res) => {
        this.consultas = res;
      });

    this.$API
      .get({
        url: "consultas-acreditacion"
      }).then((res) => {
        this.consultasAcreditacion = res;
      });
  },
};
</script>
<style scoped>

/* Sobrescribir el color del contador de archivos */
::v-deep .v-file-input .v-counter.theme--light {
  color: white !important;
}

::v-deep .v-text-field input,
::v-deep .v-textarea textarea,
::v-deep .v-file-input input {
  background-color: white !important;  
  color: black !important;  
  border: 1px solid black !important; 
  border-radius: 8px !important; 
  font-size: 14px !important; 
  padding: 8px 16px !important; 
  line-height: 1.5 !important; 
  vertical-align: middle; 
  text-align: left !important; 
}



::v-deep .v-text-field .v-label,
::v-deep .v-textarea .v-label,
::v-deep .v-file-input .v-label {
  color: rgba(0, 0, 0, 0.6) !important;  
  font-size: 14px !important; 
  transition: all 0.3s ease-in-out !important; 
  padding-left: 16px !important; 
  transform: translateY(0) !important; 
  visibility: visible !important;  
  opacity: 1 !important;  
}


::v-deep .v-text-field--focused .v-label,
::v-deep .v-textarea--focused .v-label,
::v-deep .v-file-input--focused .v-label,
::v-deep .v-text-field input:not(:placeholder-shown) + .v-label,
::v-deep .v-textarea textarea:not(:placeholder-shown) + .v-label,
::v-deep .v-file-input input:not(:placeholder-shown) + .v-label {
  color: black !important; 
  transform: translateY(-24px) !important; 
  font-weight: bold;  
  font-size: 12px !important; 
  visibility: hidden !important; 
  opacity: 0 !important;  
}

/* Estilo para los iconos */
::v-deep .v-icon {
  color: white !important;  /* Iconos en color blanco */
}


::v-deep .v-btn {
  font-size: 14px;
  text-transform: none;
  letter-spacing: 0.5px;
  padding: 8px 16px;
  color: white !important; 
  border: 1px solid black; 
}


.text-xs-h4,
.text-sm-h4,
.text-md-h4,
.text-lg-h4,
.text-xl-h4 {
  font-size: 1.5rem;  
  font-weight: bold;
  color: black;  
}


::v-deep .v-simple-table th {
  color: black !important;
  font-weight: bold;
  text-transform: uppercase;
}


::v-deep .v-file-input .v-label {
  color: white !important; 
}


@media (max-width: 600px) {
  .v-simple-table {
    overflow-x: auto;
    display: block;
    white-space: nowrap;
  }

  .v-simple-table th,
  .v-simple-table td {
    padding: 8px;
    font-size: 14px;
  }

  .hideMobile {
    display: none !important;
  }
}

@media (max-width: 768px) {
  .d-none {
    display: block !important;
  }
  .d-md-flex {
    display: none !important;
  }
}

::v-deep .v-text-field input {
  background-color: white !important;
  color: black !important;
  border: 1px solid black !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  padding: 8px 16px !important;
  line-height: 1.5 !important;
  vertical-align: middle;
  text-align: left !important;
  max-height: 50px;
  
  flex: 1 1 auto;
  line-height: 25px;
  padding: 8px 0 8px;
  max-width: 100%;
  min-width: 0px;
  width: 100%;
}

.v-text-field__slot {
  max-height: 150px !important; /* Ajusta esta altura según lo que necesites */
}
::v--deep .v-custom-input input {
    max-height: 70px;
}

::v-deep .v-icon__svg {
    height: 24px;
    width: 24px;
    fill: rgb(127, 124, 124);
}
</style>





